import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Modal, Button, IonIcon, Spinner } from 'controls'
import { TentativeParentsActionCreators } from 'app/reducers/TentativeParentsRedux'
import {
  getTentativeParents,
  getTentativeParentsLoading,
  getTentativeParentsError,
  getShowParentErrorModal,
  getShowParentConfirmModal,
  getSelectedParentForConfirmation,
} from 'app/selectors/TentativeParentsSelectors'
import ParentSelector from 'components/Forms/Profile/ParentSelector'
import { parentSelectorModalStyles } from './styles'

class ParentSelectorModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    // ParentSelector props
    tentativeParents: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    error: PropTypes.bool.isRequired,
    loadTentativeParents: PropTypes.func.isRequired,
    showParentErrorModal: PropTypes.bool,
    showParentConfirmModal: PropTypes.bool,
    selectedParentForConfirmation: PropTypes.object,
  }

  static defaultProps = {
    isOpen: false,
    showParentErrorModal: false,
    showParentConfirmModal: false,
    selectedParentForConfirmation: null,
  }

  componentDidMount() {
    // Load tentative parents when component mounts
    if (this.props.isOpen) {
      this.props.loadTentativeParents()
    }
  }

  componentDidUpdate(prevProps) {
    // Load tentative parents when modal opens
    if (!prevProps.isOpen && this.props.isOpen) {
      this.props.loadTentativeParents()
    }
  }

  handleParentSelected = (parent) => {
    // Close modal immediately after parent selection
    // The saga will handle the success message and page reload
    this.props.onClose()
  }

  renderLoadingState = () => (
    <div className="parent-modal-loading">
      <div className="loading-content">
        <Spinner size={50} />
        <h3>Cargando padrinos disponibles...</h3>
        <p>Por favor, espere mientras buscamos los mejores padrinos para usted.</p>
      </div>
    </div>
  )

  renderErrorState = () => (
    <div className="parent-modal-error">
      <div className="error-content">
        <IonIcon icon="ios-warning" />
        <h3>Error al cargar padrinos</h3>
        <p>No pudimos cargar la lista de padrinos disponibles.</p>
      </div>
      <div className="error-actions">
        <Button
          type="button"
          color="primary"
          outline
          onClick={() => this.props.loadTentativeParents()}
        >
          <IonIcon icon="ios-refresh" />
          Reintentar
        </Button>
      </div>
    </div>
  )

  renderContent = () => {
    const { isLoading, error, tentativeParents } = this.props

    if (isLoading) {
      return this.renderLoadingState()
    }

    if (error && tentativeParents.length === 0) {
      return this.renderErrorState()
    }

    return (
      <div className="parent-modal-content">
        <div className="modal-header">
          <h2>Selecciona tu padrino</h2>
        </div>
        
        <div className="parent-selector-wrapper">
          <ParentSelector
            onParentSelected={this.handleParentSelected}
            subtitleComponent={
              <p className="modal-subtitle urgent-message" style={{ 
                color: '#dc2626', 
              }}>
               ¡Ya no hay más tiempo!. Hoy es tu último día para seleccionar padrino
              </p>
            }
          />
        </div>
      </div>
    )
  }

  render() {
    const { isOpen, onClose } = this.props

    return (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="large"
        showCloseButton={false} // Modal bloqueante
        className="parent-selector-modal"
      >
        <div className="parent-selector-modal-container">
          {this.renderContent()}
          <style jsx>{parentSelectorModalStyles}</style>
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = state => ({
  tentativeParents: getTentativeParents(state),
  isLoading: getTentativeParentsLoading(state),
  error: getTentativeParentsError(state),
  showParentErrorModal: getShowParentErrorModal(state),
  showParentConfirmModal: getShowParentConfirmModal(state),
  selectedParentForConfirmation: getSelectedParentForConfirmation(state),
})

const mapDispatchToProps = dispatch => ({
  loadTentativeParents: params =>
    dispatch(TentativeParentsActionCreators.all(params)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ParentSelectorModal)
